import React from "react"
import { Drawer, RaisedButton } from "material-ui"
import autobind from "class-autobind"
import _ from "lodash"
import AppStateStore from "../../stores/AppStateStore"
import { browserHistory } from "react-router"
import HtmlLoader from "../layout/HtmlLoader"
import strings from "../../localization/strings"
import AccountStore from "../../stores/AccountStore"
import { EPlanType } from "../../models"

interface IProps {
  drawerTitle: string,
  title: string,
  description: string,
  marketingContentHTMLUrl: string,
}
interface IState {
  open: boolean,
}

export default class PayWallDrawer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      open: false,
    }
    autobind(this)
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ open: true })
    }, 2000)
  }

  render() {
    return (
      <Drawer
        open={this.state.open}
        openSecondary
        width={1200}
        docked={false}
        overlayStyle={{ zIndex: 1500 }}
        containerStyle={{ zIndex: 1500, overflow: "unset", opacity: open ? 1 : 0, transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}
        onRequestChange={() => browserHistory.replace("/dashboard")}
      >
        <div style={{ padding: 35, backgroundColor: AppStateStore.getDrawerHeaderColor(), textAlign: "center", color: "#ffffff", fontWeight: "normal", fontSize: 25 }}>
          <img src="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/paywall-lock.png" style={{ width: 20, marginTop: -8 }} /> Findd Professional - {this.props.drawerTitle}
          <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={() => browserHistory.replace("/dashboard")} />
        </div>
        <div style={{ overflow: "auto", height: "calc(100vh - 90px)" }}>
          <div style={{ display: "flex", flexDirection: "row", padding: 30 }}>
            <div style={{ width: "50%", padding: 30 }}>
              <RaisedButton
                data-intercom-target={"Paywall-Drawer-Btn-Talk-to-sales"}
                backgroundColor="#1181F2"
                labelColor="white"
                label={strings.Talk_to_Sales}
                style={{ width: "100%" }}
                onTouchTap={() => { window["Intercom"]("show") }}
              />
              {AccountStore.getCurrentAccount().BillingInfo.PlanType !== EPlanType.Enterprise &&
                <RaisedButton
                  data-intercom-target={"Paywall-Drawer-Btn-Upgrade"}
                  backgroundColor="white"
                  labelColor="#1181F2"
                  label={strings.Upgrade}
                  style={{ width: "100%", marginTop: 15, border: "2px solid #1181F2" }}
                  onTouchTap={() => AppStateStore.openAccountBillingDrawer()}
                />
              }
            </div>
            <div style={{ width: "50%", padding: 30 }}>
              <h2 style={{ marginTop: 0 }}>{this.props.title}</h2>
              <p>{this.props.description}</p>
            </div>
          </div>
          <div style={{ borderTop: "solid 1px #cccccc", marginTop: 0, marginBottom: 20 }}>
            <HtmlLoader htmlUrl={this.props.marketingContentHTMLUrl} />
          </div>
        </div>
      </Drawer>
    )
  }
}